import { gameApi } from "api/game";
import { PATH } from "constants/path";
import { ResponseCode } from "constants/response";
import { GameFavourite } from "enums/game";
import { ModalTypeValue } from "enums/modalType";
import _find from "lodash/find";
import { isMobile } from "router";
import { updateSubGamesFavourite } from "store/game";
import { getSubGamesFavourite } from "store/game/game.thunk";
import { setOpenModal } from "store/master";
import { SubGameType, UpdateFavouriteGamePayload } from "types/game";

export const checkGameFavouriteMatched = (
  game: SubGameType,
  listGameFavourite: SubGameType[],
) => {
  return !!_find(listGameFavourite, (item) => {
    return item.game_id === game.game_id;
  });
};

export const handleFavoriteGame = async (
  username: string,
  dispatch: any,
  game: SubGameType,
  listGameFavourite: SubGameType[],
  isAuthenticated: boolean,
  navigate?: any,
) => {
  if (!isAuthenticated) {
    if (isMobile) {
      navigate(PATH.Account.login);
    } else {
      dispatch(setOpenModal(ModalTypeValue.LOGIN));
    }
    return;
  }

  const isFavourited = checkGameFavouriteMatched(game, listGameFavourite);

  let newListFavourite = [];
  if (isFavourited) {
    newListFavourite = listGameFavourite.filter(
      (item) => item.game_id !== game.game_id,
    );
  } else {
    newListFavourite = [...listGameFavourite, game];
  }
  dispatch(updateSubGamesFavourite(newListFavourite));

  try {
    const payload: UpdateFavouriteGamePayload = {
      username,
      game_id: game.game_id || "",
      method: isFavourited ? GameFavourite.REMOVE : GameFavourite.ADD,
    };
    const updateResponse = await gameApi.updateMemberFavouriteGame(payload);
    if (updateResponse.status !== ResponseCode.SUCCESS) {
      return;
    }
    dispatch(getSubGamesFavourite(username));
  } catch (error) {
    //
  }
};
